<template>
    <div class="main-content " v-cloak>
        <div class="container">
            <div class="form-success">
                <div class="icon-success-big"></div>
                <div class="form-success-title">Congratulations!</div>
                <p>Subscription successful</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "success",
    data() {
        return {};
    },
    computed: {},
    watch: {},
    mounted() {},
    methods: {},
    created() {}
};
</script>
<style scoped>
@media (max-width: 82rem) {
    .main-content {
        padding: 4rem 1.6rem 0 1.6rem;
    }
}

.container {
    display: flex;
    flex-direction: column;
}

.form-success {
    margin-top: 1.2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

@media (max-width: 82rem) {
    .main-content {
        height: 60vh;
        overflow: auto;
    }
}

.form-success-title {
    margin-top: 1.2rem;
    font-weight: 600;
    font-size: 1.6rem;
    line-height: 2.4rem;
    text-align: center;
    letter-spacing: 0.02em;
    color: #000000;
}

.form-success p {
    margin-top: 0.8rem;
    font-size: 1.2rem;
    line-height: 2.4rem;
    text-align: center;
    letter-spacing: 0.02em;
    color: #717171;
}
</style>
